module.exports = __webpack_public_path__ + "static/media/08_2.7d284930.png";